import { useEffect, useRef } from "react";
import { checkAliasReserved } from "hooks/show/urlAlias/utils/checkAliasReserved";
import { apiV2 } from "api/firebase";
import { generateRedirectPath } from "hooks/show/urlAlias/utils/generateRedirectPath";
import { useSelector } from "react-redux";
import { selectUser } from "store/auth/selectors";

const useRedirectByAlias = () => {
  const hasRun = useRef<boolean>(false);
  const { role } = useSelector(selectUser);

  useEffect(() => {
    const getShowIdByURLAlias = async () => {
      const isValidRole = !role || role === "exhibitor";
      if (hasRun.current || !isValidRole) {
        return;
      }

      hasRun.current = true;

      const { pathname } = window.location;

      if (!pathname) {
        return;
      }

      try {
        const alias = pathname.split("/")[1];
        if (!alias || checkAliasReserved(alias)) {
          return;
        }

        const { showId } =
          (await apiV2.showURLAlias.getShowIdByAlias(alias)) || {};

        if (!showId) {
          return;
        }

        const path = await generateRedirectPath(showId);
        if (path) {
          window.location.replace(path);
        }
      } catch (e) {
        console.error("Error getting show ID by alias: ", e);
      }
    };
    getShowIdByURLAlias();
  }, [role]);
  return null;
};

export default useRedirectByAlias;
